export const SET_ACTIVE_STEP = '@enrollment/SET_ACTIVE_STEP';
export const SET_ENROLLMENT_TYPE = '@enrollment/SET_ENROLLMENT_TYPE';
export const SET_IS_DFIN_ADMIN = '@enrollment/SET_IS_DFIN_ADMIN';
export const SET_IS_DFIN_ADMIN_SUCCESS =
  '@enrollment/SET_IS_DFIN_ADMIN_SUCCESS';
export const SET_IS_DFIN_ADMIN_FAIL = '@enrollment/SET_IS_DFIN_ADMIN_FAIL';
export const SET_ENTITY_INFO = '@enrollment/SET_ENTITY_INFO';
export const SET_ENTITY_INFO_SUCCESS = '@enrollment/SET_ENTITY_INFO_SUCCESS';
export const SET_ENTITY_INFO_FAIL = '@enrollment/SET_ENTITY_INFO_FAIL';
export const UPLOAD_TEMPLATE_FILE = '@enrollment/UPLOAD_TEMPLATE_FILE';
export const UPLOAD_TEMPLATE_FILE_SUCCESS =
  '@enrollment/UPLOAD_TEMPLATE_FILE_SUCCESS';
export const UPLOAD_TEMPLATE_FILE_FAIL =
  '@enrollment/UPLOAD_TEMPLATE_FILE_FAIL';
export const SET_ACCOUNT_ADMIN_ONE = '@enrollment/SET_ACCOUNT_ADMIN_ONE';
export const SET_ACCOUNT_ADMIN_ONE_SUCCESS =
  '@enrollment/SET_ACCOUNT_ADMIN_ONE_SUCCESS';
export const SET_ACCOUNT_ADMIN_ONE_FAIL =
  '@enrollment/SET_ACCOUNT_ADMIN_ONE_FAIL';
export const SET_ACCOUNT_ADMIN_TWO = '@enrollment/SET_ACCOUNT_ADMIN_TWO';
export const SET_ACCOUNT_ADMIN_TWO_SUCCESS =
  '@enrollment/SET_ACCOUNT_ADMIN_TWO_SUCCESS';
export const SET_ACCOUNT_ADMIN_TWO_FAIL =
  '@enrollment/SET_ACCOUNT_ADMIN_TWO_FAIL';
export const CREATE_ENROLLMENT = '@enrollment/CREATE_ENROLLMENT';
export const CREATE_ENROLLMENT_SUCCESS =
  '@enrollment/CREATE_ENROLLMENT_SUCCESS';
export const CREATE_ENROLLMENT_FAIL = '@enrollment/CREATE_ENROLLMENT_FAIL';
export const ENROLL = '@enrollment/ENROLL';
export const ENROLL_SUCESS = '@enrollment/ENROLL_SUCESS';
export const ENROLL_FAIL = '@enrollment/ENROLL_FAIL';
export const GET_EDGAR_STATUS = '@enrollment/GET_EDGAR_STATUS';
export const GET_EDGAR_STATUS_SUCESS = '@enrollment/GET_EDGAR_STATUS_SUCESS';
export const GET_EDGAR_STATUS_FAIL = '@enrollment/GET_EDGAR_STATUS_FAIL';
export const GET_LATEST_ENROLLMENT = '@enrollment/GET_LATEST_ENROLLMENT';
export const GET_LATEST_ENROLLMENT_SUCCESS =
  '@enrollment/GET_LATEST_ENROLLMENT_SUCCESS';
export const GET_LATEST_ENROLLMENT_FAIL =
  '@enrollment/GET_LATEST_ENROLLMENT_FAIL';
export const CONTINUE_ENROLLMENT = '@enrollment/CONTINUE_ENROLLMENT';
export const CONTINUE_ENROLLMENT_SUCCESS =
  '@enrollment/CONTINUE_ENROLLMENT_SUCCESS';
export const CONTINUE_ENROLLMENT_FAIL = '@enrollment/CONTINUE_ENROLLMENT_FAIL';
export const RESET_ENROLLMENT = '@enrollment/RESET_ENROLLMENT';
export const RESET_STEP_IDS_AFTER_BULK_UPLOAD =
  '@enrollment/RESET_STEP_IDS_AFTER_BULK_UPLOAD';

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export enum EnrollmentStep {
  PATH_SELECTION = 'pathSelection',
  ENTITY_INFORMATION = 'entityInformation',
  ACCOUNT_ADMINISTRATOR_1 = 'accountAdministrator1',
  ACCOUNT_ADMINISTRATOR_2 = 'accountAdministrator2',
  BULK = 'bulk',
  REVIEW = 'review',
  COMPLETE = 'complete',
}

export const ENROLLMENT_STEPS_SINGLE: EnrollmentStep[] = [
  EnrollmentStep.PATH_SELECTION,
  EnrollmentStep.ENTITY_INFORMATION,
  EnrollmentStep.ACCOUNT_ADMINISTRATOR_1,
  EnrollmentStep.ACCOUNT_ADMINISTRATOR_2,
  EnrollmentStep.REVIEW,
  EnrollmentStep.COMPLETE,
];

export const ENROLLMENT_STEPS_MULTIPLE: EnrollmentStep[] = [
  EnrollmentStep.PATH_SELECTION,
  EnrollmentStep.ENTITY_INFORMATION,
  EnrollmentStep.REVIEW,
  EnrollmentStep.COMPLETE,
];

export const ENROLLMENT_STEP_TITLES: Record<EnrollmentStep, string> = {
  [EnrollmentStep.PATH_SELECTION]: 'Path Selection',
  [EnrollmentStep.ENTITY_INFORMATION]: 'Entity Information',
  [EnrollmentStep.ACCOUNT_ADMINISTRATOR_1]: 'Account Administrator 1',
  [EnrollmentStep.ACCOUNT_ADMINISTRATOR_2]: 'Account Administrator 2',
  [EnrollmentStep.BULK]: 'Bulk',
  [EnrollmentStep.REVIEW]: 'Review',
  [EnrollmentStep.COMPLETE]: 'Complete',
};

export enum EdgarStatus {
  UP = 'UP',
  DOWN = 'DOWN',
}

export enum EnrollmentType {
  SINGLE_ENTITY = 'singleEntity',
  MULTIPLE_ENTITY = 'multipleEntity',
}

export enum AnnualReviewDate {
  MARCH_31 = 'march31',
  JUNE_30 = 'june30',
  SEPTEMBER_30 = 'september30',
  DECEMBER_31 = 'december31',
}

export const ANNUAL_REVIEW_DATE_TITLES: Record<AnnualReviewDate, string> = {
  [AnnualReviewDate.MARCH_31]: 'March 31',
  [AnnualReviewDate.JUNE_30]: 'June 30',
  [AnnualReviewDate.SEPTEMBER_30]: 'September 30',
  [AnnualReviewDate.DECEMBER_31]: 'December 31',
};

export const STATES_MAP: Record<string, string> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  B5: 'American Samoa',
  GU: 'Guam',
};

export const US_COUNTRY_CODE: string = 'X1';
export const NON_US_STATE: string = 'NONE';

export const COUNTRIES_MAP: Record<string, string> = {
  B2: 'Afghanistan',
  Y6: 'Aland Islands',
  B3: 'Albania',
  B4: 'Algeria',
  B6: 'Andorra',
  B7: 'Angola',
  '1A': 'Anguilla',
  B8: 'Antarctica',
  B9: 'Antigua And Barbuda',
  C1: 'Argentina',
  '1B': 'Armenia',
  '1C': 'Aruba',
  C3: 'Australia',
  C4: 'Austria',
  '1D': 'Azerbaijan',
  C5: 'Bahamas',
  C6: 'Bahrain',
  C7: 'Bangladesh',
  C8: 'Barbados',
  '1F': 'Belarus',
  C9: 'Belgium',
  D1: 'Belize',
  G6: 'Benin',
  D0: 'Bermuda',
  D2: 'Bhutan',
  D3: 'Bolivia',
  '1E': 'Bosnia And Herzegovina',
  B1: 'Botswana',
  D4: 'Bouvet Island',
  D5: 'Brazil',
  D6: 'British Indian Ocean Territory',
  D9: 'Brunei Darussalam',
  E0: 'Bulgaria',
  X2: 'Burkina Faso',
  E2: 'Burundi',
  E3: 'Cambodia',
  E4: 'Cameroon',
  Z4: 'Canada (Federal Level)',
  E8: 'Cape Verde',
  E9: 'Cayman Islands',
  F0: 'Central African Republic',
  F2: 'Chad',
  F3: 'Chile',
  F4: 'China',
  F6: 'Christmas Island',
  F7: 'Cocos (Keeling) Islands',
  F8: 'Colombia',
  F9: 'Comoros',
  G0: 'Congo',
  Y3: 'Congo, The Democratic Republic Of The',
  G1: 'Cook Islands',
  G2: 'Costa Rica',
  L7: "Cote D'Ivoire",
  '1M': 'Croatia',
  G3: 'Cuba',
  G4: 'Cyprus',
  '2N': 'Czech Republic',
  G7: 'Denmark',
  '1G': 'Djibouti',
  G9: 'Dominica',
  G8: 'Dominican Republic',
  H1: 'Ecuador',
  H2: 'Egypt',
  H3: 'El Salvador',
  H4: 'Equatorial Guinea',
  '1J': 'Eritrea',
  '1H': 'Estonia',
  H5: 'Ethiopia',
  H7: 'Falkland Islands (Malvinas)',
  H6: 'Faroe Islands',
  H8: 'Fiji',
  H9: 'Finland',
  I0: 'France',
  I3: 'French Guiana',
  I4: 'French Polynesia',
  '2C': 'French Southern Territories',
  I5: 'Gabon',
  I6: 'Gambia',
  '2Q': 'Georgia',
  '2M': 'Germany',
  J0: 'Ghana',
  J1: 'Gibraltar',
  J3: 'Greece',
  J4: 'Greenland',
  J5: 'Grenada',
  J6: 'Guadeloupe',
  J8: 'Guatemala',
  Y7: 'Guernsey',
  J9: 'Guinea',
  S0: 'Guinea-Bissau',
  K0: 'Guyana',
  K1: 'Haiti',
  K4: 'Heard Island And Mcdonald Islands',
  X4: 'Holy See (Vatican City State)',
  K2: 'Honduras',
  K3: 'Hong Kong',
  K5: 'Hungary',
  K6: 'Iceland',
  K7: 'India',
  K8: 'Indonesia',
  K9: 'Iran, Islamic Republic Of',
  L0: 'Iraq',
  L2: 'Ireland',
  Y8: 'Isle Of Man',
  L3: 'Israel',
  L6: 'Italy',
  L8: 'Jamaica',
  M0: 'Japan',
  Y9: 'Jersey',
  M2: 'Jordan',
  '1P': 'Kazakstan',
  M3: 'Kenya',
  J2: 'Kiribati',
  M4: "Korea, Democratic People'S Republic Of",
  M5: 'Korea, Republic Of',
  M6: 'Kuwait',
  '1N': 'Kyrgyzstan',
  M7: "Lao People'S Democratic Republic",
  '1R': 'Latvia',
  M8: 'Lebanon',
  M9: 'Lesotho',
  N0: 'Liberia',
  N1: 'Libyan Arab Jamahiriya',
  N2: 'Liechtenstein',
  '1Q': 'Lithuania',
  N4: 'Luxembourg',
  N5: 'Macau',
  '1U': 'Macedonia, The Former Yugoslav Republic Of',
  N6: 'Madagascar',
  N7: 'Malawi',
  N8: 'Malaysia',
  N9: 'Maldives',
  O0: 'Mali',
  O1: 'Malta',
  '1T': 'Marshall Islands',
  O2: 'Martinique',
  O3: 'Mauritania',
  O4: 'Mauritius',
  '2P': 'Mayotte',
  O5: 'Mexico',
  '1K': 'Micronesia, Federated States Of',
  '1S': 'Moldova, Republic Of',
  O9: 'Monaco',
  P0: 'Mongolia',
  Z5: 'Montenegro',
  P1: 'Montserrat',
  P2: 'Morocco',
  P3: 'Mozambique',
  E1: 'Myanmar',
  T6: 'Namibia',
  P5: 'Nauru',
  P6: 'Nepal',
  P7: 'Netherlands',
  P8: 'Netherlands Antilles',
  '1W': 'New Caledonia',
  Q2: 'New Zealand',
  Q3: 'Nicaragua',
  Q4: 'Niger',
  Q5: 'Nigeria',
  Q6: 'Niue',
  Q7: 'Norfolk Island',
  '1V': 'Northern Mariana Islands',
  Q8: 'Norway',
  P4: 'Oman',
  R0: 'Pakistan',
  '1Y': 'Palau',
  '1X': 'Palestinian Territory, Occupied',
  R1: 'Panama',
  R2: 'Papua New Guinea',
  R4: 'Paraguay',
  R5: 'Peru',
  R6: 'Philippines',
  R8: 'Pitcairn',
  R9: 'Poland',
  S1: 'Portugal',
  PR: 'Puerto Rico',
  S3: 'Qatar',
  S4: 'Reunion',
  S5: 'Romania',
  '1Z': 'Russian Federation',
  S6: 'Rwanda',
  Z0: 'Saint Barthelemy',
  U8: 'Saint Helena',
  U7: 'Saint Kitts And Nevis',
  U9: 'Saint Lucia',
  Z1: 'Saint Martin',
  V0: 'Saint Pierre And Miquelon',
  V1: 'Saint Vincent And The Grenadines',
  Y0: 'Samoa',
  S8: 'San Marino',
  S9: 'Sao Tome And Principe',
  T0: 'Saudi Arabia',
  T1: 'Senegal',
  Z2: 'Serbia',
  T2: 'Seychelles',
  T8: 'Sierra Leone',
  U0: 'Singapore',
  '2B': 'Slovakia',
  '2A': 'Slovenia',
  D7: 'Solomon Islands',
  U1: 'Somalia',
  T3: 'South Africa',
  '1L': 'South Georgia And The South Sandwich Islands',
  U3: 'Spain',
  F1: 'Sri Lanka',
  V2: 'Sudan',
  V3: 'Suriname',
  L9: 'Svalbard And Jan Mayen',
  V6: 'Swaziland',
  V7: 'Sweden',
  V8: 'Switzerland',
  V9: 'Syrian Arab Republic',
  F5: 'Taiwan',
  '2D': 'Tajikistan',
  W0: 'Tanzania, United Republic Of',
  W1: 'Thailand',
  Z3: 'Timor-Leste',
  W2: 'Togo',
  W3: 'Tokelau',
  W4: 'Tonga',
  W5: 'Trinidad And Tobago',
  W6: 'Tunisia',
  W8: 'Turkey',
  '2E': 'Turkmenistan',
  W7: 'Turks And Caicos Islands',
  '2G': 'Tuvalu',
  W9: 'Uganda',
  '2H': 'Ukraine',
  C0: 'United Arab Emirates',
  X0: 'United Kingdom',
  [US_COUNTRY_CODE]: 'United States',
  '2J': 'United States Minor Outlying Islands',
  X3: 'Uruguay',
  '2K': 'Uzbekistan',
  '2L': 'Vanuatu',
  X5: 'Venezuela',
  Q1: 'Viet Nam',
  D8: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  X8: 'Wallis And Futuna',
  U5: 'Western Sahara',
  T7: 'Yemen',
  Y4: 'Zambia',
  Y5: 'Zimbabwe',
  XX: 'Unknown',
};

export const CANADIAN_PROVINCES_MAP: Record<string, string> = {
  A0: 'Alberta, Canada',
  A1: 'British Columbia, Canada',
  A2: 'Manitoba, Canada',
  A3: 'New Brunswick, Canada',
  A4: 'Newfoundland, Canada',
  A5: 'Nova Scotia, Canada',
  A6: 'Ontario, Canada',
  A7: 'Prince Edward Island, Canada',
  A8: 'Quebec, Canada',
  A9: 'Saskatchewan, Canada',
  B0: 'Yukon, Canada',
  Z4: 'Canada (Federal Level)',
};

export interface EntityInfoFormData {
  reviewDate: AnnualReviewDate;
  cik: string;
  ccc: string;
  passphrase: string;
  names?: string[];
}

export interface AccountAdminData {
  email: string;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  phoneNumber: string;
  nonUSAddress: boolean;
}

export interface EnrollmentStepDTO {
  stepId: string;
  enrollmentId: string;
  stepName: EnrollmentStep;
  stepData: string;
  lastModified: string;
}

export interface EnrollmentStepIds {
  pathSelection: string;
  entityInformation: string;
  accountAdministrator1: string;
  accountAdministrator2: string;
  bulk: string;
}

export enum TemplateUploadStatus {
  NOT_STARTED = 'notStarted',
  UPLOADING = 'uploading',
  SUCCESS = 'success',
  FAIL = 'fail',
}

export const TEMPLATE_ERROR: string =
  'We detected an unknown issue with your workbook. Please ensure the workbook has not been altered in any way. (additional columns, values not in a labeled column etc.)';

export interface EnrollmentState {
  enrollmentSteps: EnrollmentStep[];
  enrollmentStepIds: EnrollmentStepIds;
  enrollmentType: EnrollmentType;
  activeStep: EnrollmentStep;
  isDFINAdmin: boolean;
  enrollmentId: string;
  entityInfo: EntityInfoFormData;
  templateUploadStatus: TemplateUploadStatus;
  templateUploadError?: string;
  accountAdminOne: AccountAdminData;
  accountAdminTwo: AccountAdminData;
  isLoading: boolean;
  isEdgarAvailable: boolean;
  latestEnrollmentId?: string;
}
